module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//6.jpg?51db6915fc20358cb3627e655dc75bc2";